import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table_virtual = _resolveComponent("v-data-table-virtual")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_data_table_virtual, {
        headers: _ctx.headers,
        items: _ctx.filteredItems,
        "hide-default-footer": "",
        "fixed-header": "",
        "calculate-widths": "",
        loading: _ctx.loading,
        height: "70vh",
        class: "table"
      }, {
        item: _withCtx((props) => [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
              return (_openBlock(), _createElementBlock("td", {
                key: index,
                class: "px-4"
              }, [
                (index === 0)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "font-weight-medium"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.item.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "font-weight-medium"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                        props.item.amountsPerMonth[index - 1],
                                        undefined,
                                    )), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["headers", "items", "loading"])
    ]),
    _: 1
  }))
}